import React from "react";
import ContactForm from "./ContactForm";

const WorkwithUs: React.FC = () => {
  return (
    <div className="w-full">
      {/* <div className="w-full flex justify-start pl-6 sm:pl-0">
        <Link to="/careers">
          <button className="w-fit px-4 py-2 text-xs lg:text-base xl:text-[1.3rem] lg:px-6 xl:px-6 lg:py-2 sm:text-sm bg-[#00BB68] hover:bg-opacity-90 transition-all duration-200 ease-out text-white rounded-full">
            Explore what it's like to work with us
          </button>
        </Link>
      </div> */}
      <div className="py-5 sm:p-7 lg:p-10 grid md:grid-cols-2 gap-10">
        <div className="flex flex-col justify-center items-center">
          <h4 className="text-lg text-left w-full sm:text-xl md:text-2xl lg:text-4xl xl:text-[2.9rem]">
            Who are we ?
          </h4>
          <div className="text-xs md:text-sm font-medium lg:text-base xl:text-lg lg:pt-4 xl:pt-6 space-y-3 pt-3">
            {/* <p>
              Visioncraft was established in 2019 on the basis of the product
              development department of the parent company Levercode. Levercode
              was founded in 2014 and continuously contributes to the Estonian
              digital revolution.
            </p> */}
            <p>
              Founded in 2003, Dream Weavers began as a modest training center
              dedicated to skill development. Over the years, we have evolved
              into a prominent force in corporate training, recruitment,
              staffing, and tech-driven tourism solutions. With a robust
              presence across 12 states in India, we have expanded our impact,
              empowering individuals and organizations alike. Our dynamic team
              of over 300 talented professionals delivers tailored, innovative
              solutions that drive growth and success. Dream Weavers is
              committed to shaping the future through transformative learning
              experiences and cutting-edge technology, making us a trusted
              partner in the development of talent and industry advancement.
            </p>
          </div>
        </div>
        <div className="flex justify-center md:justify-center lg:pl-10 xl:pl-44">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default WorkwithUs;
